import type { CSSProperties } from 'react'

import { SCHRIFTFAMILIEN } from '@/design/tokens'
import type { DialektTheme } from '@/lib/api'

/**
 * Dialekt-Theming als Stilobjekt.
 *
 * Gesetzt werden nur die `--mu-*`-Variablen; die Tailwind-Farben zeigen darauf.
 * Weil Custom Properties sich vererben, genügt es, sie auf der Karte zu setzen —
 * damit trägt jede Übertragung ihre eigene Palette, ohne dass die Seite
 * umgefärbt werden müsste oder eine Auswahl nötig wäre.
 */
export function themeStil(theme: DialektTheme): CSSProperties {
  return {
    '--mu-primary': theme.primary,
    '--mu-on-primary': theme.on_primary,
    '--mu-surface': theme.surface,
    '--mu-surface-container': theme.surface_container,
    '--mu-on-surface': theme.on_surface,
    '--mu-on-surface-muted': theme.on_surface_muted,
    '--mu-accent': theme.accent,
    '--mu-outline': theme.outline,
    '--mu-font-display': SCHRIFTFAMILIEN[theme.display_font],
  } as CSSProperties
}
